import api from '../../api-client';

export const searchService = {
  // One page of results; searchActions.run pages through to the total.
  async search({ q, kinds = [], limit = 200, offset = 0 }) {
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    kinds.forEach((k) => params.append('kind', k));
    params.set('limit', String(limit));
    if (offset) params.set('offset', String(offset));
    const res = await api.get(`/api/search?${params.toString()}`);
    return res.data;
  },
  async kinds() {
    const res = await api.get('/api/search/kinds');
    return res.data;
  },
};
